export default __webpack_public_path__ + "static/NotoSansThaiBold.subset-e44d47475c133e060694fdb5323bfc8d.woff";